import React, { Component } from 'react';
import { connect } from 'react-redux';

import SearchField from '../components/SearchField';
import ClearFilters from '../components/ClearFilters';
import PracticeField from '../components/PracticeField';
import IndustryField from '../components/IndustryField';
import AttorneyField from '../components/AttorneyField';
import TypeField from '../components/TypeField';

//actions
import { updateFilterSelected } from '../actions';

class FilterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reset: false,
      query: null
    };
  }

  getUrlParams = () => {
    let urlString = window.location.search;
    let industry;
    let practice;
    //console.log(urlString)
    urlString = urlString.replace('?', '').split('|');
    urlString.map((element, index) => {
      //console.log(element);
      if (element.includes('practice')) {
        practice = decodeURI(element.replace('practice=', ''));
      }
      if (element.includes('industry')) {
        industry = decodeURI(element.replace('industry=', ''));
      }
    });

    return {
      practice: practice,
      industry: industry
    };
  };

  componentDidMount() {
    //get query string
    //console.log(this.getUrlParams('practice'))
    //console.log(this.getUrlParams().industry);
    if (window.location.search) {
      this.setState({
        query: {
          practice: this.getUrlParams().practice,
          industry: this.getUrlParams().industry
        }
      });
    }
  }

  render() {
    return (
      <div className="">
        <div className="row">
          <SearchField />
          <div className="form-group form-group-columned form-group-lined col-sm-12 col-md-5 col-lg-4">
            <TypeField />
          </div>
          <div className="form-group form-group-columned form-group-lined col-sm-12 col-md-5 col-lg-4">
            <PracticeField query={this.state.query} />
          </div>
          <div className="form-group form-group-columned form-group-lined col-sm-12 col-md-5 col-lg-4">
            <IndustryField query={this.state.query} />
          </div>
          <div className="form-group form-group-columned form-group-lined col-sm-12 col-md-5 col-lg-4">
            <AttorneyField />
          </div>
        </div>

        <div className="float-right">
          <ClearFilters />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateFilterSelected: (filtername, value) => dispatch(updateFilterSelected(filtername, value))
  };
};

const mapStateToProps = state => {
  return {
    filters: state.filters
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterContainer);
